// 多语言翻译文件
const translations = {
  en: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    // 应用名称和标语
    appName: "PicapicaBooth",
    tagline: "Free Online Photo Booth",
    free: "FREE",
    homeBrowserPromise: "Open in browser, no download, free.",
    homeStartFree: "Start Photo Booth — Free",
    
    // 导航
    home: "Home",
    features: "Features",
    gallery: "Gallery",
    photoBooth: "Photo Booth",
    preview: "Preview",
    tutorial: "Tutorial",
    reviews: "Reviews",
    
    // 主页
    heroTitle: "Create Beautiful Photo Strips with our Online Photo Booth",
    heroDescription: "PicapicaBooth lets you easily capture, edit, and share stunning photos without professional equipment, anytime, anywhere. Our advanced AI-powered filters and professional-grade photo processing ensure every shot looks amazing.",
    noDownloadRequired: "No Download Required",
    privateAndSecure: "Private & Secure",
    unlimitedPhotos: "Unlimited Photos",
    getStarted: "Get Started",
    learnMore: "Learn More",
    
    // 照相亭
    photoBoothTitle: "Picapica Booth - Free Online Photo Booth",
    photoInstruction: "Adjust your settings, select a filter, and click \"Start Capture\" to create your photo strip!",
    photoSettings: "Photo Settings",
    startCapture: "Start Capture",
    capturing: "Capturing your Picapica Booth photos...",
    
    // 滤镜类别
    standardFilters: "Standard Filters",
    professionalFilters: "Professional Filters",
    artisticFilters: "Artistic Filters",
    
    // 滤镜名称
    noFilter: "No Filter",
    grayscale: "Grayscale",
    sepia: "Sepia",
    highContrast: "High Contrast",
    bright: "Bright",
    
    // 专业滤镜
    portraitEnhance: "Portrait Enhance",
    dramaticLight: "Dramatic Light",
    advancedBW: "Advanced B&W",
    filmLook: "Film Look",
    
    // 艺术滤镜
    dreamyBlue: "Dreamy Blue",
    vintageGreen: "Vintage Green",
    negative: "Negative",
    darkMood: "Dark Mood",
    
    // 智能推荐
    smartDetection: "Smart light detection",
    darkLight: "low light",
    brightLight: "bright light",
    normalLight: "normal light",
    recommendFilter: "Recommended filter for best results",
    applyRecommended: "Apply Recommendation",
    
    // 照片预览
    previewTitle: "Picapica Booth Photo Preview",
    layoutStyles: "Choose Layout Style",
    classicStrip: "Classic Strip",
    gridLayout: "Grid Layout",
    polaroidStyle: "Polaroid Style",
    magazineCover: "Magazine Cover",
    
    // 背景颜色
    backgroundColor: "Choose Background Color",
    white: "White",
    black: "Black",
    pink: "Pink",
    green: "Green",
    blue: "Blue",
    yellow: "Yellow",
    purple: "Purple",
    
    // 装饰选项
    decorations: "Choose Decorations",
    girlStickers: "Girl Stickers",
    cuteStickers: "Cute Stickers",
    noStickers: "No Stickers",
    
    // 按钮
    download: "Download Picapica Booth Photo Strip",
    takeNew: "Take New Photos with Picapica Booth",
    share: "Share Your PicapicaBooth Creation",
    
    // 分享
    shareTitle: "Share Your Picapica Booth Creation",
    socialMedia: "Social Media",
    emailInvite: "Email Invite",
    copyLink: "Copy Link",
    linkCopied: "Link Copied!",
    
    // 教程相关
    tutorialBasics: "Photography Basics",
    poseTutorial: "Posing Guide", 
    filterGuide: "Filter Guide",
    troubleshootingGuide: "Troubleshooting",
    photoTutorialTitle: "Complete Photography Tutorial",
    photoTutorialIntro: "Master the art of photography with our comprehensive guide covering everything from basic lighting to advanced techniques.",
    
    lightingTips: "Lighting Techniques",
    lightingTipsDesc: "Understanding light is crucial for great photos. Natural light often produces the best results for portrait photography.",
    naturalLightTip: "Use natural light whenever possible - position yourself near a window or outdoors",
    avoidHarshShadowsTip: "Avoid harsh shadows by using diffused light or reflectors",
    goldenHourTip: "Golden hour (sunrise/sunset) provides the most flattering natural light",
    diffuseLightTip: "Cloudy days provide excellent diffused lighting for portraits",
    
    compositionRules: "Composition Techniques",
    compositionRulesDesc: "Good composition is the foundation of compelling photography. These rules will help you create visually appealing photos.",
    ruleOfThirdsTip: "Place important elements along the rule of thirds grid lines",
    leadingLinesTip: "Use leading lines to guide the viewer's eye to your subject",
    framingTip: "Frame your subject using natural elements like doorways or branches",
    symmetryTip: "Look for symmetry and patterns to create balanced compositions",
    
    individualPoses: "Individual Posing",
    individualPosesDesc: "Help your subjects look their best with these proven posing techniques for individual portraits.",
    relaxedPostureTip: "Keep posture relaxed and natural - avoid stiff, formal poses",
    eyeContactTip: "Direct eye contact creates connection - look straight at the camera",
    handPlacementTip: "Be mindful of hand placement - avoid awkward or distracting positions",
    expressionVarietyTip: "Try different expressions - serious, smiling, laughing",
    
    groupPoses: "Group Photography",
    groupPosesDesc: "Capturing groups requires different techniques to ensure everyone looks great and the composition works well.",
    heightVariationTip: "Vary heights by having people sit, stand, or kneel for dynamic composition",
    closeGroupingTip: "Keep group members close together to create intimacy and connection",
    naturalInteractionTip: "Encourage natural interactions between group members",
    everyoneFocusTip: "Ensure everyone can see the camera and is in focus",
    
    choosingFilters: "Choosing the Right Filter",
    choosingFiltersDesc: "Filters can enhance your photos, but choosing the right one depends on your subject, lighting, and desired mood.",
    moodMatchingTip: "Match filter mood to your photo's content - warm for happy moments, cool for dramatic scenes",
    skinToneTip: "Consider how filters affect skin tones - avoid filters that create unnatural skin colors",
    occasionAppropriatenessTip: "Choose filters appropriate for the occasion - subtle for professional photos, bold for creative shots",
    subtletyTip: "Less is often more - subtle adjustments usually look more professional",
    
    customFilters: "Creating Custom Effects",
    customFiltersDesc: "Learn to manually adjust photo settings to create your own unique look and style.",
    adjustBrightnessTip: "Adjust brightness to properly expose your subject without losing detail",
    contrastBalanceTip: "Balance contrast to add depth while maintaining natural skin tones",
    colorTemperatureTip: "Adjust color temperature to match the lighting conditions or create mood",
    saturationControlTip: "Control saturation to enhance colors without making them look artificial",
    
    commonIssues: "Common Technical Issues",
    commonIssuesDesc: "Troubleshoot common problems you might encounter while using the photo booth.",
    blurryPhotosTip: "Keep the camera steady and ensure good lighting to avoid blurry photos",
    poorLightingTip: "If photos are too dark, move closer to a light source or increase brightness",
    cameraPermissionTip: "Make sure to allow camera permissions when prompted by your browser",
    browserCompatibilityTip: "Use a modern browser like Chrome, Firefox, Safari, or Edge for best performance",
    
    qualityOptimization: "Photo Quality Tips",
    qualityOptimizationDesc: "Get the highest quality results from your photo sessions with these optimization techniques.",
    cameraResolutionTip: "Ensure your camera is set to the highest available resolution",
    steadyHandsTip: "Keep your hands steady or use a tripod for sharper images",
    cleanLensTip: "Clean your camera lens regularly for crisp, clear photos",
    goodAngleTip: "Find your best angle and lighting setup before starting your session",
    
    proTipsTitle: "Professional Tips",
    proTipsIntro: "Take your photography to the next level with these professional techniques and insights.",
    proTip1Title: "Master Your Environment",
    proTip1Desc: "Scout your location beforehand and understand how light changes throughout the day for consistently great shots.",
    proTip2Title: "Connect with Subjects",
    proTip2Desc: "Build rapport with your subjects to capture genuine expressions and natural poses that tell a story.",
    proTip3Title: "Timing is Everything",
    proTip3Desc: "Wait for the right moment - genuine smiles, perfect light, and natural interactions make the best photos.",
    proTip4Title: "Post-Processing Finesse",
    proTip4Desc: "Learn subtle editing techniques that enhance rather than overpower your original image.",
    
    readyToStart: "Ready to Create Amazing Photos?",
    tutorialCTADesc: "Now that you've learned the techniques, put them into practice with our photo booth tool.",
    startPhotoSession: "Start Photo Session",
    
    tutorialFAQTitle: "Photography Tutorial FAQ",
    tutorialFAQ1Q: "Do I need professional equipment to take great photos?",
    tutorialFAQ1A: "No! While professional equipment can help, understanding lighting, composition, and posing techniques can dramatically improve photos taken with any camera, including smartphones.",
    tutorialFAQ2Q: "What's the most important factor in photography?",
    tutorialFAQ2A: "Lighting is arguably the most crucial factor. Good lighting can make an average photo look great, while poor lighting can ruin even the best composition.",
    tutorialFAQ3Q: "How do I choose the right filter for my photo?",
    tutorialFAQ3A: "Consider the mood you want to convey, the lighting conditions, and your subject. Start with subtle adjustments and preview the result before applying.",
    tutorialFAQ4Q: "Why are my photos always blurry?",
    tutorialFAQ4A: "Blur usually comes from camera movement or poor lighting. Keep the camera steady, ensure adequate lighting, and make sure your subject isn't moving during capture.",
    
    // 使用指南相关
    userGuideTitle: "Complete User Guide",
    userGuideIntro: "Everything you need to know to get the most out of PicapicaBooth - from basic operations to advanced features.",
    
    stepByStepGuide: "Step-by-Step Instructions",
    guideStep1Title: "Setting Up Your Camera",
    guideStep1Overview: "Learn how to properly configure your camera settings for the best photo booth experience.",
    guideStep2Title: "Taking Perfect Photos",
    guideStep2Overview: "Master the photo capture process with our detailed shooting guide.",
    guideStep3Title: "Applying Filters and Effects",
    guideStep3Overview: "Enhance your photos with professional filters and custom adjustments.",
    guideStep4Title: "Creating Photo Strips",
    guideStep4Overview: "Generate beautiful photo strips with various layouts and styles.",
    guideStep5Title: "Saving and Sharing",
    guideStep5Overview: "Download your creations and share them across social platforms.",
    
    accessingCamera: "Camera Access",
    accessingCameraDesc: "PicapicaBooth needs camera permission to function. Your browser will prompt for permission when you first use the photo booth.",
    
    cameraSettings: "Camera Configuration",
    cameraSettingsDesc: "Optimize your camera settings for the best photo quality and user experience.",
    resolutionTip: "Select the highest available resolution for best quality",
    facingModeTip: "Choose front or rear camera based on your setup",
    
    frameComposition: "Framing Your Shot",
    frameCompositionDesc: "Position yourself or your subjects properly within the camera frame for optimal results.",
    centeringTip: "Center subjects in the frame while leaving some breathing room",
    spacingTip: "For group photos, ensure everyone fits comfortably in the frame",
    
    captureSequence: "Photo Capture Process",
    captureSequenceDesc: "Follow the on-screen prompts to capture your sequence of photos for the strip.",
    timingTip: "Wait for the countdown before moving or changing poses",
    countdownTip: "Use the countdown timer to prepare for each shot",
    
    retakeOptions: "Retaking Photos",
    retakeOptionsDesc: "Don't settle for less than perfect - you can retake individual photos or the entire sequence.",
    qualityCheckTip: "Review each photo before proceeding to the next",
    expressionTip: "Try different expressions for variety in your strip",
    
    filterSelection: "Choosing Filters",
    filterSelectionDesc: "Browse through our collection of filters to find the perfect look for your photos.",
    filterPreviewTip: "Preview filters in real-time before applying them",
    styleMatchingTip: "Choose filters that match your intended style or mood",
    
    customization: "Custom Adjustments",
    customizationDesc: "Fine-tune your photos with manual adjustments for brightness, contrast, and color balance.",
    brightnessAdjustmentTip: "Adjust brightness to compensate for lighting conditions",
    contrastTip: "Increase contrast for more dramatic effects",
    
    effects: "Special Effects",
    effectsDesc: "Add creative touches with our selection of artistic effects and overlays.",
    
    stripGeneration: "Creating Your Strip",
    stripGenerationDesc: "Choose from various layout options to create your final photo strip design.",
    layoutOptionsTip: "Try different layouts to see what works best with your photos",
    orientationTip: "Choose portrait or landscape orientation based on your intended use",
    
    qualitySettings: "Output Quality",
    qualitySettingsDesc: "Select the appropriate quality settings for your intended use of the photo strip.",
    resolutionChoiceTip: "Choose high resolution for printing, standard for social sharing",
    compressionTip: "Balance file size with quality based on your needs",
    
    downloadOptions: "Download Your Photos",
    downloadOptionsDesc: "Save your photo strips to your device in various formats and sizes.",
    formatChoiceTip: "JPG for photos, PNG for graphics with transparency",
    sizingTip: "Choose size based on intended use - larger for printing, smaller for web",
    
    socialSharing: "Share on Social Media",
    socialSharingDesc: "Instantly share your creations on popular social media platforms.",
    platformOptimizationTip: "Each platform has different optimal image sizes and formats",
    hashtagTip: "Use relevant hashtags to increase visibility of your posts",
    
    cloudStorage: "Cloud Storage Options",
    cloudStorageDesc: "Save your photo strips to cloud storage services for easy access across devices.",
    privacyTip: "Your photos are processed locally and not stored on our servers",
    accessibilityTip: "Cloud storage ensures you can access your photos from any device",
    
    troubleshootingTitle: "Troubleshooting Common Issues",
    troubleshootingIntro: "Find solutions to the most frequently encountered problems and learn how to prevent them.",
    
    cameraNotWorking: "Camera Not Responding",
    cameraNotWorkingSolution: "Check browser permissions, refresh the page, or try a different browser. Ensure no other applications are using your camera.",
    
    photoBlurry: "Photos Are Blurry",
    photoBlurrySolution: "Improve lighting conditions, hold the camera steady, clean your lens, and ensure subjects remain still during capture.",
    
    slowPerformance: "Slow App Performance",
    slowPerformanceSolution: "Close other browser tabs, restart your browser, clear browser cache, or try using a different browser with better performance.",
    
    downloadIssues: "Cannot Download Photos",
    downloadIssuesSolution: "Check your browser's download settings, ensure you have sufficient storage space, and verify popup blocker settings.",
    
    filterNotApplying: "Filters Not Working",
    filterNotApplyingSolution: "Refresh the page, try a different filter first, or check if your browser supports the required image processing features.",
    
    mobileIssues: "Mobile Device Problems",
    mobileIssuesSolution: "Rotate to landscape mode, ensure stable internet connection, close other apps to free memory, or try using a desktop browser.",
    
    advancedFeaturesTitle: "Advanced Features",
    advancedFeaturesIntro: "Unlock the full potential of PicapicaBooth with these advanced techniques and features.",
    
    batchProcessing: "Batch Photo Processing",
    batchProcessingDesc: "Process multiple photo sessions efficiently with batch operations and saved settings.",
    batchStep1: "Capture multiple photo sessions back-to-back",
    batchStep2: "Apply consistent filter settings across all sessions",
    batchStep3: "Generate multiple photo strips with the same layout",
    batchStep4: "Download all strips in a single ZIP file",
    
    customTemplates: "Custom Template Creation",
    customTemplatesDesc: "Design your own photo strip templates with custom layouts, colors, and branding.",
    templateStep1: "Choose base layout and orientation",
    templateStep2: "Customize background colors and patterns",
    templateStep3: "Add text, logos, or decorative elements",
    templateStep4: "Save template for future use",
    
    qualityOptimizationDesc: "Fine-tune image processing settings for the highest possible output quality.",
    qualityStep1: "Configure camera resolution settings",
    qualityStep2: "Adjust compression and sharpening parameters",
    qualityStep3: "Optimize color space and bit depth",
    qualityStep4: "Preview and validate final output quality",
    
    keyboardShortcuts: "Keyboard Shortcuts",
    shortcutsIntro: "Speed up your workflow with these helpful keyboard shortcuts.",
    capturePhoto: "Capture Photo",
    confirmSelection: "Confirm Selection",
    cancelOperation: "Cancel Operation",
    retakePhoto: "Retake Photo",
    toggleFullscreen: "Toggle Fullscreen",
    selectFilter: "Select Filter (1-9)",
    
    readyToTryTitle: "Ready to Try It Yourself?",
    readyToTryDesc: "Put your new knowledge to work and start creating amazing photo strips right away.",
    viewPhotoTips: "View Photo Tips",
    
    needMoreHelp: "Need More Help?",
    supportIntro: "Can't find what you're looking for? We're here to help you succeed.",
    contactSupport: "Contact Support",
    contactSupportDesc: "Get direct help from our support team",
    browseFAQ: "Browse FAQ",
    browseFAQDesc: "Find answers to common questions",
    readBlog: "Read Our Blog",
    readBlogDesc: "Tips, tricks, and creative inspiration",

    photoTips: "Photo Tips",
    userGuide: "User Guide",

    // FAQ
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Common questions about PicapicaBooth",
    faq1Q: "Is PicapicaBooth really free to use?",
    faq1A: "Yes, PicapicaBooth is completely free! You can create unlimited photo strips without any cost or subscription fees.",
    faq2Q: "Do I need to download any software?",
    faq2A: "No downloads required! PicapicaBooth works directly in your web browser on any device with a camera.",
    faq3Q: "What devices and browsers are supported?",
    faq3A: "PicapicaBooth works on desktop computers, laptops, tablets, and smartphones. We recommend Chrome, Firefox, Safari, or Edge browsers for the best experience.",
    faq4Q: "Are my photos stored on your servers?",
    faq4A: "No, your privacy is important to us. All photo processing happens locally on your device, and we don't store any of your photos on our servers.",
    faq5Q: "Can I use PicapicaBooth offline?",
    faq5A: "While you need an internet connection to load the app initially, once loaded, most features work offline. However, sharing features require an internet connection.",
    faq6Q: "How do I get the best photo quality?",
    faq6A: "For best results, ensure good lighting, keep your camera steady, clean your lens, and use the highest resolution setting available on your device.",
    faq7Q: "Can I customize the photo strip layouts?",
    faq7A: "Yes! PicapicaBooth offers multiple layout options including classic strips, grid layouts, Polaroid style, and magazine covers with various color backgrounds.",
    faq8Q: "What photo formats can I download?",
    faq8A: "You can download your photo strips in JPG format, which is perfect for sharing on social media or printing. Different resolution options are available.",
    faq9Q: "Why aren't my filters working properly?",
    faq9A: "If filters aren't applying correctly, try refreshing the page, ensuring you have a stable internet connection, or using a different browser that fully supports modern web features.",
    faq10Q: "Can I use PicapicaBooth for commercial purposes?",
    faq10A: "PicapicaBooth is designed for personal use. For commercial applications like events or business use, please contact us to discuss licensing options.",
    
    // 页脚
    copyright: "© 2025 PicapicaBooth. All Rights Reserved.",
    about: "About Us",
    contact: "Contact Us",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    
    // 语言切换
    switchToChinese: "Switch to Chinese",
    switchToEnglish: "Switch to English",
    
    // Showcase
    showcaseTitle: "Unlimited Creativity, Stunning Results",
    showcaseIntro: "Check out beautiful photo strips created by users with PicapicaBooth",
    showcaseAlt1: "Photo strip example 1",
    showcaseAlt2: "Photo strip example 2",
    showcaseAlt3: "Photo strip example 3",
    showcaseAlt4: "Photo strip example 4",

    // CTA
    ctaTitle: "Ready to Create Your Photo Strip with PicapicaBooth?",
    ctaDesc: "Start using PicapicaBooth now to capture and share your amazing moments!",
    newHomeCtaTitle: "Ready to Create Amazing Photos?",
    newHomeCtaSubtitle: "Join thousands of users who love PicapicaBooth. Start creating your photo strips now!",
    newHomeCtaButton: "Start Now - It's Free!",

    // Footer
    footerSlogan: "Create beautiful photo strips with our online photo booth",
    footerProduct: "Product",
    footerSupport: "Support",
    footerCompany: "Company",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    aboutUs: "About Us",
    blog: "Blog",
    careers: "Careers",
    footerCopyright: "All Rights Reserved.",

    // Share page
    sharePageTitle: "Your PicapicaBooth Photo Strip",
    sharePageSubtitle: "Download or share this photo strip created with PicapicaBooth.",
    sharePageDownload: "Download Photo",
    sharePageCreateOwn: "Create Your Own Photo Strip",
    sharePageErrorTitle: "Photo not found",
    sharePageErrorDescription: "This shared photo may have expired, been removed, or the link is incorrect.",
    sharePageReturnHome: "Go to Home",
    sharePageTryApp: "Try PicapicaBooth",
    shareGeneratingLink: "Preparing your shareable link...",
    shareGenerationError: "We couldn't create a share link right now. Download the photo and copy it manually instead.",

    // Features
    powerfulFeatures: "Powerful Features",
    featuresIntro: "Everything you need to create professional-quality photo strips online.",
    newHomeScrollHint: "Discover More Features",
    newHomeFeaturesIntro: "Everything you need to create amazing photo booth strips",
    newHomeAiTitle: "AI Background Removal",
    newHomeAiDescription: "Professional AI-powered background removal in seconds. Choose from 13+ backgrounds or upload your own.",
    newHomeLayoutsTitle: "Multiple Layouts",
    newHomeLayoutsDescription: "8+ photo strip layouts to choose from. Classic, modern, or creative styles.",
    newHomeFiltersTitle: "Creative Filters",
    newHomeFiltersDescription: "Apply beautiful filters and effects to make your photos stand out.",
    newHomeSharingTitle: "Easy Sharing",
    newHomeSharingDescription: "Share directly to Facebook, Twitter, Instagram, WeChat, and Weibo.",
    newHomeFreeTitle: "100% Free",
    newHomeFreeDescription: "No hidden fees, no subscriptions. Completely free to use forever.",
    newHomePrivacyTitle: "Privacy Protected",
    newHomePrivacyDescription: "All processing happens locally in your browser. Your photos never leave your device.",
    newHomeFeaturesCta: "Start Creating Now",
    professionalQuality: "Professional Quality",
    professionalQualityDesc: "Advanced image processing algorithms ensure crisp, vibrant photos every time",
    instantResults: "Instant Results", 
    instantResultsDesc: "See your photo strips generated in real-time with zero waiting",
    crossPlatform: "Cross Platform",
    crossPlatformDesc: "Works seamlessly on desktop, tablet, and mobile devices",
    
    photoCapture: "Photo Capture",
    photoCaptureDesc: "Easily take high-quality photos with your device using our optimized camera interface.",
    creativeFilters: "Creative Filters",
    creativeFiltersDesc: "Apply a variety of fun and artistic filters to your photos with real-time preview.",
    photoStripGeneration: "Photo Strip Generation",
    photoStripGenerationDesc: "Automatically generate classic photo strips with multiple layout options.",
    easySharing: "Easy Sharing",
    easySharingDesc: "Share your creations instantly with friends and social media platforms.",

    // Workflow
    workflowTitle: "How It Works",
    workflowIntro: "Just three simple steps to create your perfect photo strip.",
    workflowStep1: "Take Photos",
    workflowStep1Desc: "Capture your best moments using your camera.",
    workflowStep2: "Edit & Decorate",
    workflowStep2Desc: "Apply filters and add decorations to personalize your photos.",
    workflowStep3: "Download & Share",
    workflowStep3Desc: "Save your photo strip or share it with friends.",

    // Testimonials
    testimonialsTitle: "What Our Users Say",
    testimonialsIntro: "Real feedback from PicapicaBooth users.",
    testimonial1Name: "Emily Johnson",
    testimonial1Role: "Photographer",
    testimonial1Comment: "PicapicaBooth is so easy to use and the results are amazing!",
    testimonial2Name: "Michael Lee",
    testimonial2Role: "Event Organizer",
    testimonial2Comment: "Our guests loved the instant photo strips. Highly recommended!",
    testimonial3Name: "Sophia Chen",
    testimonial3Role: "Student",
    testimonial3Comment: "A fun way to capture memories with friends online.",

    // FAQ
    faqTitle: "Frequently Asked Questions",
    faqIntro: "Here are the answers to common questions about PicapicaBooth.",
    newHomeFaqIntro: "Got questions? We've got answers!",
    newHomeFaqCta: "Ready to Start? Go to Camera",
    newHomeFaq1Question: "Is picapica photo booth really free?",
    newHomeFaq1Answer: "Yes! PicapicaBooth is completely free to use. No hidden fees, no subscriptions, no downloads required. Just open your browser and start creating photo booth strips.",
    newHomeFaq2Question: "Do I need to download software for pica pica booth?",
    newHomeFaq2Answer: "No downloads needed! PicapicaBooth works directly in your web browser. Just visit picapicabooth.app and you're ready to go.",
    newHomeFaq3Question: "Can I use pica pica photobooth on my phone?",
    newHomeFaq3Answer: "Absolutely! PicapicaBooth works on any device with a camera and web browser - smartphones, tablets, laptops, and desktop computers.",
    newHomeFaq4Question: "How many photos can I take?",
    newHomeFaq4Answer: "Unlimited! Take as many photos as you want. There are no limits on the number of photo strips you can create.",
    newHomeFaq5Question: "Does pikapika photobooth have AI background removal?",
    newHomeFaq5Answer: "Yes! PicapicaBooth features professional AI background removal that's completely free. Remove backgrounds from your photos in seconds and choose from 13+ different backgrounds or upload your own. All processing happens locally in your browser for maximum privacy.",
    newHomeFaq6Question: "Are my photos safe and private?",
    newHomeFaq6Answer: "Yes! All photo processing happens locally in your browser. Your photos are never uploaded to our servers. We take your privacy seriously.",
    faq1Q: "Is PicapicaBooth free to use?",
    faq1A: "Yes, PicapicaBooth is completely free for everyone.",
    faq2Q: "Do I need to install any software?",
    faq2A: "No installation required. You can use PicapicaBooth directly in your browser.",
    faq3Q: "Can I use PicapicaBooth on my phone?",
    faq3A: "Yes, PicapicaBooth works on both desktop and mobile devices.",
    faq4Q: "How can I share my photo strips?",
    faq4A: "You can download your photo strips or share them directly to social media.",

    // 新增的语言选择翻译
    selectLanguage: 'Select Language',

    // Beauty Features
    beautyFeature: "Beauty Features",
    enableBeauty: "Enable Beauty",
    smoothLevel: "Smooth",
    brightnessLevel: "Brightness",
    enhanceLevel: "Enhance",
    faceSlimLevel: "Face Slim",
    eyeEnlargeLevel: "Eye Enlarge",
    resetBeauty: "Reset",
    natural: "Natural",
    fresh: "Fresh",
    glamour: "Glamour",
    cute: "Cute",
  },
  
  zh: {
    quickFilters: "快速滤镜",
    moreFilters: "更多滤镜",
    hideMoreFilters: "收起滤镜",
    finalResultPreview: "最终效果预览",
    exampleDescription: "这就是你的照片条最终效果！",
    withFilters: "含滤镜",
    downloadable: "可下载",
    photos: "张照片",
    loading: "加载中...",
    cameraPermissionDenied: "需要相机权限才能使用照相亭功能。请允许访问相机。",
    cameraNotFound: "未检测到摄像头设备。请确保您的设备有摄像头并且已连接。",
    cameraInUse: "摄像头可能被其他应用程序占用。请关闭可能使用摄像头的其他应用，然后刷新页面。",
    cameraAccessError: "无法访问相机。请刷新页面重试，并检查浏览器设置。",
    cameraPlaybackError: "无法播放摄像头视频。请刷新页面重试，或检查浏览器设置。",
    noAccountTitle: "无需注册账号",
    noAccountDescription: "Picapica Booth 完全免费。无需账号、注册或订阅，即可制作你的照片条。",
    contactName: "你的姓名",
    contactEmail: "你的邮箱",
    contactMessage: "留言内容",
    contactSend: "发送留言",
    homeBrowserPromise: "浏览器直接开拍，无需下载，免费使用。",
    homeStartFree: "一键开拍 · 免费",
    // 应用名称和标语
    appName: "PicapicaBooth",
    tagline: "即时创建照片亭照片条",
    free: "免费",
    
    // 导航
    home: "首页",
    features: "功能",
    gallery: "画廊",
    photoBooth: "照相亭",
    preview: "预览",
    tutorial: "使用教程",
    reviews: "用户评价",
    
    // 主页
    heroTitle: "使用我们的在线照相亭创建精美照片条",
    heroDescription: "PicapicaBooth让您随时随地轻松捕捉、编辑和分享精美照片，无需专业设备。",
    getStarted: "立即开始",
    learnMore: "了解更多",
    
    // 照相亭
    photoBoothTitle: "Picapica Booth - 免费在线照相亭",
    photoInstruction: "调整设置，选择滤镜，然后点击'开始拍摄'创建您的照片条！",
    photoSettings: "照片设置",
    startCapture: "开始拍摄",
    capturing: "正在拍摄您的Picapica Booth照片...",
    
    // 滤镜类别
    standardFilters: "标准滤镜",
    professionalFilters: "专业滤镜",
    artisticFilters: "艺术滤镜",
    
    // 滤镜名称
    noFilter: "原始",
    grayscale: "黑白",
    sepia: "复古",
    highContrast: "高对比度",
    bright: "明亮",
    
    // 专业滤镜
    portraitEnhance: "人像增强",
    dramaticLight: "戏剧光效",
    advancedBW: "高级黑白",
    filmLook: "胶片质感",
    
    // 艺术滤镜
    dreamyBlue: "梦幻蓝",
    vintageGreen: "复古绿",
    negative: "负片效果",
    darkMood: "暗黑风格",
    
    // 智能推荐
    smartDetection: "智能检测到",
    darkLight: "光线较暗",
    brightLight: "光线较强",
    normalLight: "光线适中",
    recommendFilter: "推荐使用优化滤镜以获得最佳效果",
    applyRecommended: "应用推荐",
    
    // 照片预览
    previewTitle: "照片预览",
    layoutStyles: "选择排版样式",
    classicStrip: "经典条幅",
    gridLayout: "网格布局",
    polaroidStyle: "宝丽来风格",
    magazineCover: "杂志封面",
    vintageFilm: "复古胶片",
    comicStyle: "漫画风格",
    photoCollage: "照片拼贴",
    socialMedia: "社交媒体",
    chooseBackgroundColor: "选择背景颜色",
    white: "白色",
    black: "黑色",
    pink: "粉色",
    green: "绿色",
    blue: "蓝色",
    yellow: "黄色",
    purple: "紫色",
    chooseFrameStyle: "选择边框样式",
    noFrame: "无边框",
    pastelHearts: "马卡龙爱心",
    cuteClouds: "可爱云朵",
    partyTime: "派对时刻",
    royalStyle: "皇家风格",
    emojiFun: "表情趣味",
    downloadPhotoStrip: "下载照片条",
    takeNewPhotos: "重新拍照",
    shareOnSocialMedia: "分享到社交媒体",
    
    // 装饰选项
    decorations: "选择装饰贴纸",
    girlStickers: "少女贴纸",
    cuteStickers: "可爱贴纸",
    noStickers: "无贴纸",
    
    // 按钮
    download: "下载Picapica Booth照片条",
    takeNew: "用Picapica Booth拍摄新照片",
    share: "分享您的PicapicaBooth作品",
    
    // 分享
    shareTitle: "分享您的Picapica Booth作品",
    emailInvite: "邮件邀请",
    copyLink: "复制链接",
    linkCopied: "链接已复制！",
    
    // FAQ
    faqTitle: "常见问题",
    faqSubtitle: "关于PicapicaBooth的常见问题",
    
    // 页脚
    copyright: "© 2025 PicapicaBooth. 保留所有权利。",
    about: "关于我们",
    contact: "联系我们",
    privacy: "隐私政策",
    terms: "服务条款",
    
    // 语言切换
    switchToChinese: "切换到中文",
    switchToEnglish: "切换到英文",
    
    // Showcase
    showcaseTitle: "无限创意，惊艳效果",
    showcaseIntro: "看看用户用PicapicaBooth创作的精美照片条",
    showcaseAlt1: "照片条示例1",
    showcaseAlt2: "照片条示例2",
    showcaseAlt3: "照片条示例3",
    showcaseAlt4: "照片条示例4",

    // CTA
    ctaTitle: "准备好用PicapicaBooth制作你的照片条了吗？",
    ctaDesc: "立即使用PicapicaBooth，捕捉并分享你的精彩瞬间！",
    newHomeCtaTitle: "准备好创作惊艳照片了吗？",
    newHomeCtaSubtitle: "加入数千名热爱 PicapicaBooth 的用户，现在就开始制作照片条！",
    newHomeCtaButton: "立即开始 - 完全免费！",

    // Footer
    footerSlogan: "用我们的在线照相亭创作精美照片条",
    footerProduct: "产品",
    footerSupport: "支持",
    footerCompany: "公司",
    contactUs: "联系我们",
    privacyPolicy: "隐私政策",
    aboutUs: "关于我们",
    blog: "博客",
    careers: "招聘",
    footerCopyright: "保留所有权利。",

    // Share page
    sharePageTitle: "你的 PicapicaBooth 照片条",
    sharePageSubtitle: "下载或分享这张通过 PicapicaBooth 创作的照片条。",
    sharePageDownload: "下载照片",
    sharePageCreateOwn: "自己动手制作照片条",
    sharePageErrorTitle: "找不到照片",
    sharePageErrorDescription: "分享的照片可能已过期、被删除或链接不正确。",
    sharePageReturnHome: "返回首页",
    sharePageTryApp: "立即体验 PicapicaBooth",
    shareGeneratingLink: "正在生成可分享的链接...",
    shareGenerationError: "暂时无法生成分享链接，请下载照片后再手动分享。",

    // Features
    newHomeScrollHint: "探索更多功能",
    newHomeFeaturesIntro: "满足你创作线上照片条的一切需求",
    newHomeAiTitle: "AI背景移除",
    newHomeAiDescription: "专业级AI背景移除，数秒完成。支持13+背景或自定义上传。",
    newHomeLayoutsTitle: "多种布局",
    newHomeLayoutsDescription: "超过8种照片条布局可选，经典、现代或创意风格。",
    newHomeFiltersTitle: "创意滤镜",
    newHomeFiltersDescription: "应用精美滤镜与特效，让照片更加出彩。",
    newHomeSharingTitle: "便捷分享",
    newHomeSharingDescription: "一键分享到 Facebook、Twitter、Instagram、微信、微博等平台。",
    newHomeFreeTitle: "100%免费",
    newHomeFreeDescription: "无隐藏费用，无订阅，永远免费使用。",
    newHomePrivacyTitle: "隐私保护",
    newHomePrivacyDescription: "所有处理均在浏览器本地完成，照片不会离开你的设备。",
    newHomeFeaturesCta: "立即开始创作",
    photoCapture: "拍照",
    photoCaptureDesc: "使用您的设备轻松拍摄高质量照片。",
    creativeFilters: "创意滤镜",
    creativeFiltersDesc: "为照片添加多种有趣和艺术滤镜。",
    photoStripGeneration: "照片条生成",
    photoStripGenerationDesc: "自动生成经典照片条。",
    easySharing: "便捷分享",
    easySharingDesc: "一键分享您的作品到好友和社交平台。",

    // Workflow
    workflowTitle: "使用流程",
    workflowIntro: "只需三步，轻松制作完美照片条。",
    workflowStep1: "拍摄照片",
    workflowStep1Desc: "用相机捕捉精彩瞬间。",
    workflowStep2: "编辑装饰",
    workflowStep2Desc: "添加滤镜和装饰，个性化您的照片。",
    workflowStep3: "下载分享",
    workflowStep3Desc: "保存照片条或分享给好友。",

    // Testimonials
    testimonialsTitle: "用户评价",
    testimonialsIntro: "来自 PicapicaBooth 用户的真实反馈。",
    testimonial1Name: "艾米丽·约翰逊",
    testimonial1Role: "摄影师",
    testimonial1Comment: "PicapicaBooth 非常易用，效果令人惊艳！",
    testimonial2Name: "李明",
    testimonial2Role: "活动策划",
    testimonial2Comment: "我们的嘉宾都很喜欢即时照片条，强烈推荐！",
    testimonial3Name: "陈思佳",
    testimonial3Role: "学生",
    testimonial3Comment: "和朋友们一起在线留住美好回忆，真的很有趣。",

    // FAQ
    faqTitle: "常见问题",
    faqIntro: "这里有关于 PicapicaBooth 的常见问题解答。",
    newHomeFaqIntro: "有疑问？我们来解答！",
    newHomeFaqCta: "准备好开始了吗？回到相机",
    newHomeFaq1Question: "PicapicaBooth 真的是免费的吗？",
    newHomeFaq1Answer: "是的！PicapicaBooth 完全免费，无隐藏费用、无订阅、无需下载。打开浏览器即可使用。",
    newHomeFaq2Question: "需要下载软件吗？",
    newHomeFaq2Answer: "无需下载！PicapicaBooth 直接在浏览器中运行，访问 picapicabooth.app 即可。",
    newHomeFaq3Question: "可以在手机上使用吗？",
    newHomeFaq3Answer: "当然！只要设备有摄像头和浏览器，无论手机、平板还是电脑都能使用。",
    newHomeFaq4Question: "我可以拍多少张照片？",
    newHomeFaq4Answer: "不限次数！想拍多少拍多少，生成的照片条数量没有限制。",
    newHomeFaq5Question: "支持AI背景移除吗？",
    newHomeFaq5Answer: "支持！免费提供专业级AI背景移除，可选择13+背景或自定义上传，全部在浏览器本地处理。",
    newHomeFaq6Question: "我的照片安全吗？",
    newHomeFaq6Answer: "放心！所有照片处理都在本地完成，图片不会上传到服务器，我们非常重视你的隐私。",
    faq1Q: "PicapicaBooth 是免费的吗？",
    faq1A: "是的，PicapicaBooth 对所有用户完全免费。",
    faq2Q: "需要安装软件吗？",
    faq2A: "无需安装，您可以直接在浏览器中使用 PicapicaBooth。",
    faq3Q: "可以在手机上使用吗？",
    faq3A: "可以，PicapicaBooth 支持桌面和移动设备。",
    faq4Q: "如何分享我的照片条？",
    faq4A: "您可以下载照片条或直接分享到社交平台。",

    // 语言选择
    selectLanguage: '选择语言',

    // Beauty Features
    beautyFeature: "美颜功能",
    enableBeauty: "开启美颜",
    smoothLevel: "磨皮",
    brightnessLevel: "美白",
    enhanceLevel: "增强",
    faceSlimLevel: "瘦脸",
    eyeEnlargeLevel: "大眼",
    resetBeauty: "重置",
    natural: "自然",
    fresh: "清新",
    glamour: "精致",
    cute: "可爱",
  },
  
  id: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    appName: "PicapicaBooth",
    tagline: "Buat Strip Foto Booth Secara Instan",
    
    // 语言选择
    selectLanguage: 'Pilih Bahasa',
    
    // 导航菜单
    features: "Fitur",
    gallery: "Galeri",
    home: "Beranda",
    photoBooth: "Booth Foto",
    preview: "Pratinjau",
    tutorial: "Tutorial",
    reviews: "Ulasan",
    heroTitle: "Buat Strip Foto Indah dengan Booth Foto Online kami",
    heroDescription: "PicapicaBooth memungkinkan Anda dengan mudah mengambil, mengedit, dan membagikan foto menakjubkan tanpa peralatan profesional, kapan saja, di mana saja.",
    getStarted: "Mulai",
    learnMore: "Pelajari Lebih Lanjut",
    photoBoothTitle: "Picapica Booth - Booth Foto Online Gratis",
    photoInstruction: "Atur pengaturan Anda, pilih filter, dan klik 'Mulai Pengambilan' untuk membuat strip foto Anda!",
    photoSettings: "Pengaturan Foto",
    startCapture: "Mulai Pengambilan",
    capturing: "Mengambil foto Picapica Booth Anda...",
    standardFilters: "Filter Standar",
    professionalFilters: "Filter Profesional",
    artisticFilters: "Filter Artistik",
    noFilter: "Tanpa Filter",
    grayscale: "Abu-abu",
    sepia: "Sepia",
    highContrast: "Kontras Tinggi",
    bright: "Cerah",
    portraitEnhance: "Peningkatan Potret",
    dramaticLight: "Cahaya Dramatis",
    advancedBW: "Hitam & Putih Lanjutan",
    filmLook: "Tampilan Film",
    dreamyBlue: "Biru Mimpi",
    vintageGreen: "Hijau Vintage",
    negative: "Negatif",
    darkMood: "Suasana Gelap",
    smartDetection: "Deteksi cahaya pintar",
    darkLight: "cahaya redup",
    brightLight: "cahaya terang",
    normalLight: "cahaya normal",
    recommendFilter: "Filter yang direkomendasikan untuk hasil terbaik",
    applyRecommended: "Terapkan Rekomendasi",
    previewTitle: "Pratinjau Foto Booth Picapica",
    layoutStyles: "Pilih Gaya Tata Letak",
    classicStrip: "Strip Klasik",
    gridLayout: "Tata Letak Grid",
    polaroidStyle: "Gaya Polaroid",
    magazineCover: "Sampul Majalah",
    backgroundColor: "Pilih Warna Latar Belakang",
    white: "Putih",
    black: "Hitam",
    pink: "Merah Muda",
    green: "Hijau",
    blue: "Biru",
    yellow: "Kuning",
    purple: "Ungu",
    decorations: "Pilih Dekorasi",
    girlStickers: "Stiker Gadis",
    cuteStickers: "Stiker Lucu",
    noStickers: "Tanpa Stiker",
    download: "Unduh Strip Foto Picapica Booth",
    takeNew: "Ambil Foto Baru dengan Picapica Booth",
    share: "Bagikan Karya PicapicaBooth Anda",
    shareTitle: "Bagikan Karya Picapica Booth Anda",
    socialMedia: "Media Sosial",
    emailInvite: "Undangan Email",
    copyLink: "Salin Tautan",
    linkCopied: "Tautan Disalin!",
    faqTitle: "Pertanyaan yang Sering Diajukan",
    faqSubtitle: "Pertanyaan umum tentang PicapicaBooth",
    copyright: "© 2025 PicapicaBooth. Semua Hak Dilindungi.",
    about: "Tentang Kami",
    contact: "Hubungi Kami",
    privacy: "Kebijakan Privasi",
    terms: "Syarat Layanan",
    switchToChinese: "Beralih ke Bahasa Mandarin",
    switchToEnglish: "Beralih ke Bahasa Inggris",
    showcaseTitle: "Kreativitas Tanpa Batas, Hasil Menakjubkan",
    showcaseIntro: "Lihat strip foto indah yang dibuat oleh pengguna dengan PicapicaBooth",
    showcaseAlt1: "Contoh strip foto 1",
    showcaseAlt2: "Contoh strip foto 2",
    showcaseAlt3: "Contoh strip foto 3",
    showcaseAlt4: "Contoh strip foto 4",
    ctaTitle: "Siap Membuat Strip Foto Anda dengan PicapicaBooth?",
    ctaDesc: "Mulai gunakan PicapicaBooth sekarang untuk menangkap dan membagikan momen menakjubkan Anda!",
    footerSlogan: "Buat strip foto indah dengan booth foto online kami",
    footerProduct: "Produk",
    footerSupport: "Dukungan",
    footerCompany: "Perusahaan",
    contactUs: "Hubungi Kami",
    privacyPolicy: "Kebijakan Privasi",
    aboutUs: "Tentang Kami",
    blog: "Blog",
    careers: "Karir",
    footerCopyright: "Semua Hak Dilindungi.",
    photoCapture: "Pengambilan Foto",
    photoCaptureDesc: "Ambil foto berkualitas tinggi dengan perangkat Anda dengan mudah.",
    creativeFilters: "Filter Kreatif",
    creativeFiltersDesc: "Terapkan berbagai filter menyenangkan dan artistik ke foto Anda.",
    photoStripGeneration: "Pembuatan Strip Foto",
    photoStripGenerationDesc: "Secara otomatis menghasilkan strip foto klasik.",
    easySharing: "Chia Sẻ Dễ Dàng",
    easySharingDesc: "Chia sẻ tác phẩm của bạn ngay lập tức với bạn bè và mạng xã hội.",
    workflowTitle: "Cách Kerjanya",
    workflowIntro: "Hanya tiga langkah sederhana untuk membuat strip foto sempurna Anda.",
    workflowStep1: "Ambil Foto",
    workflowStep1Desc: "Tangkap momen terbaik Anda menggunakan kamera Anda.",
    workflowStep2: "Edit & Dekorasi",
    workflowStep2Desc: "Terapkan filter dan tambahkan dekorasi untuk mempersonalisasi foto Anda.",
    workflowStep3: "Unduh & Bagikan",
    workflowStep3Desc: "Simpan strip foto Anda atau bagikan dengan teman.",
    testimonialsTitle: "Apa Kata Pengguna Kami",
    testimonialsIntro: "Umpan balik nyata dari pengguna PicapicaBooth.",
    testimonial1Name: "Emily Johnson",
    testimonial1Role: "Fotografer",
    testimonial1Comment: "PicapicaBooth sangat mudah digunakan dan hasilnya luar biasa!",
    testimonial2Name: "Michael Lee",
    testimonial2Role: "Penyelenggara Acara",
    testimonial2Comment: "Tamu kami menyukai strip foto instan. Sangat direkomendasikan!",
    testimonial3Name: "Sophia Chen",
    testimonial3Role: "Mahasiswa",
    testimonial3Comment: "Cara menyenangkan untuk mengabadikan kenangan bersama teman secara online.",
    faqIntro: "Berikut adalah jawaban untuk pertanyaan umum tentang PicapicaBooth.",
    faq1Q: "Apakah PicapicaBooth gratis digunakan?",
    faq1A: "Ya, PicapicaBooth sepenuhnya gratis untuk semua orang.",
    faq2Q: "Apakah saya perlu menginstal perangkat lunak apa pun?",
    faq2A: "Tidak perlu instalasi. Anda dapat menggunakan PicapicaBooth langsung di browser Anda.",
    faq3Q: "Bisakah saya menggunakan PicapicaBooth di ponsel saya?",
    faq3A: "Ya, PicapicaBooth berfungsi di desktop dan perangkat seluler.",
    faq4Q: "Bagaimana cara membagikan strip foto saya?",
    faq4A: "Anda dapat mengunduh strip foto Anda atau membagikannya langsung ke media sosial."
  },
  vi: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    appName: "PicapicaBooth",
    tagline: "Tạo Dải Ảnh Tức Thì",
    
    // 语言选择
    selectLanguage: 'Chọn Ngôn ngữ',
    
    // 导航菜单
    features: "Tính năng",
    gallery: "Thư viện",
    home: "Trang Chủ",
    photoBooth: "Buồng Chụp Ảnh",
    preview: "Xem Trước",
    tutorial: "Hướng Dẫn",
    reviews: "Đánh Giá",
    heroTitle: "Tạo Dải Ảnh Đẹp với Buồng Chụp Ảnh Trực Tuyến của chúng tôi",
    heroDescription: "PicapicaBooth cho phép bạn dễ dàng chụp, chỉnh sửa và chia sẻ những bức ảnh tuyệt đẹp mà không cần thiết bị chuyên nghiệp, bất cứ lúc nào, bất cứ đâu.",
    getStarted: "Bắt Đầu",
    learnMore: "Tìm Hiểu Thêm",
    photoBoothTitle: "Picapica Booth - Buồng Chụp Ảnh Trực Tuyến Miễn Phí",
    photoInstruction: "Điều chỉnh cài đặt, chọn bộ lọc và nhấp vào 'Bắt Đầu Chụp' để tạo dải ảnh của bạn!",
    photoSettings: "Cài Đặt Ảnh",
    startCapture: "Bắt Đầu Chụp",
    capturing: "Đang chụp ảnh Picapica Booth của bạn...",
    standardFilters: "Bộ Lọc Tiêu Chuẩn",
    professionalFilters: "Bộ Lọc Chuyên Nghiệp",
    artisticFilters: "Bộ Lọc Nghệ Thuật",
    noFilter: "Không Bộ Lọc",
    grayscale: "Thang Xám",
    sepia: "Nâu Đỏ",
    highContrast: "Độ Tương Phản Cao",
    bright: "Sáng",
    portraitEnhance: "Tăng Cường Chân Dung",
    dramaticLight: "Ánh Sáng Kịch Tính",
    advancedBW: "Đen Trắng Nâng Cao",
    filmLook: "Phong Cách Phim",
    dreamyBlue: "Xanh Mộng Mơ",
    vintageGreen: "Xanh Lá Cổ Điển",
    negative: "Âm Bản",
    darkMood: "Tâm Trạng Tối",
    smartDetection: "Phát hiện ánh sáng thông minh",
    darkLight: "ánh sáng yếu",
    brightLight: "ánh sáng mạnh",
    normalLight: "ánh sáng bình thường",
    recommendFilter: "Bộ lọc được đề xuất để có kết quả tốt nhất",
    applyRecommended: "Áp Dụng Đề Xuất",
    previewTitle: "Xem Trước Ảnh Buồng Picapica",
    layoutStyles: "Chọn Kiểu Bố Cục",
    classicStrip: "Dải Ảnh Cổ Điển",
    gridLayout: "Bố Cục Lưới",
    polaroidStyle: "Phong Cách Polaroid",
    magazineCover: "Bìa Tạp Chí",
    backgroundColor: "Chọn Màu Nền",
    white: "Trắng",
    black: "Đen",
    pink: "Hồng",
    green: "Xanh Lá",
    blue: "Xanh Dương",
    yellow: "Vàng",
    purple: "Tím",
    decorations: "Chọn Trang Trí",
    girlStickers: "Sticker Cô Gái",
    cuteStickers: "Sticker Dễ Thương",
    noStickers: "Không Sticker",
    download: "Tải Xuống Dải Ảnh Picapica Booth",
    takeNew: "Chụp Ảnh Mới với Picapica Booth",
    share: "Chia Sẻ Tác Phẩm PicapicaBooth Của Bạn",
    shareTitle: "Chia Sẻ Tác Phẩm Picapica Booth Của Bạn",
    socialMedia: "Mạng Xã Hội",
    emailInvite: "Lời Mời Email",
    copyLink: "Sao Chép Liên Kết",
    linkCopied: "Đã Sao Chép Liên Kết!",
    faqTitle: "Câu Hỏi Thường Gặp",
    faqSubtitle: "Câu hỏi phổ biến về PicapicaBooth",
    copyright: "© 2025 PicapicaBooth. Tất Cả Quyền Được Bảo Lưu.",
    about: "Về Chúng Tôi",
    contact: "Liên Hệ",
    privacy: "Chính Sách Bảo Mật",
    terms: "Điều Khoản Dịch Vụ",
    switchToChinese: "Chuyển sang Tiếng Trung",
    switchToEnglish: "Chuyển sang Tiếng Anh",
    showcaseTitle: "Sáng Tạo Không Giới Hạn, Kết Quả Ấn Tượng",
    showcaseIntro: "Xem các dải ảnh đẹp được tạo bởi người dùng với PicapicaBooth",
    showcaseAlt1: "Ví dụ dải ảnh 1",
    showcaseAlt2: "Ví dụ dải ảnh 2",
    showcaseAlt3: "Ví dụ dải ảnh 3",
    showcaseAlt4: "Ví dụ dải ảnh 4",
    ctaTitle: "Sẵn Sàng Tạo Dải Ảnh Của Bạn với PicapicaBooth หรือยัง?",
    ctaDesc: "Bắt đầu sử dụng PicapicaBooth ตอนนี้เพื่อถ่ายและแชร์ช่วงเวลาที่ยอดเยี่ยมของคุณ!",
    footerSlogan: "Tạo dải ảnh đẹp với buồng chụp ảnh trực tuyến của chúng tôi",
    footerProduct: "Sản Phẩm",
    footerSupport: "Hỗ Trợ",
    footerCompany: "Công Ty",
    contactUs: "Liên Hệ Chúng Tôi",
    privacyPolicy: "Chính Sách Bảo Mật",
    aboutUs: "Về Chúng Tôi",
    blog: "Blog",
    careers: "Tuyển Dụng",
    footerCopyright: "Tất Cả Quyền Được Bảo Lưu.",
    photoCapture: "Chụp Ảnh",
    photoCaptureDesc: "Dễ dàng chụp ảnh chất lượng cao với thiết bị của bạn.",
    creativeFilters: "ฟิลเตอร์สร้างสรรค์",
    creativeFiltersDesc: "ใช้ฟิลเตอร์สนุกๆ และศิลปะหลากหลายกับภาพถ่ายของคุณ",
    photoStripGeneration: "การสร้างสตริปภาพ",
    photoStripGenerationDesc: "สร้างสตริปภาพคลาสสิกโดยอัตโนมัติ",
    easySharing: "แชร์ง่าย",
    easySharingDesc: "แชร์ผลงานของคุณกับเพื่อนและโซเชียลมีเดียได้ทันที",
    workflowTitle: "วิธีการทำงาน",
    workflowIntro: "Chỉ ba bước đơn giản để tạo dải ảnh hoàn hảo của bạn.",
    workflowStep1: "Chụp ảnh",
    workflowStep1Desc: "Chụp những khoảnh khắc đẹp nhất của bạn bằng máy ảnh.",
    workflowStep2: "Chỉnh Sửa & Trang Trí",
    workflowStep2Desc: "Áp dụng bộ lọc và thêm trang trí để cá nhân hóa ảnh của bạn.",
    workflowStep3: "Tải Xuống & Chia Sẻ",
    workflowStep3Desc: "Lưu dải ảnh của bạn hoặc chia sẻ với bạn bè.",
    testimonialsTitle: "Người Dùng Nói Gì",
    testimonialsIntro: "Phản hồi thực tế từ người dùng PicapicaBooth.",
    testimonial1Name: "Emily Johnson",
    testimonial1Role: "Nhiếp Ảnh Gia",
    testimonial1Comment: "PicapicaBooth rất dễ sử dụng và hasilnya luar biasa!",
    testimonial2Name: "Michael Lee",
    testimonial2Role: "Người Tổ Chức Sự Kiện",
    testimonial2Comment: "Tamu kami menyukai strip foto instan. Sangat direkomendasikan!",
    testimonial3Name: "Sophia Chen",
    testimonial3Role: "Sinh Viên",
    testimonial3Comment: "Một cách thú vị để lưu giữ kỷ niệm với bạn bè trực tuyến.",
    faqIntro: "Đây là câu trả lời cho các câu hỏi phổ biến về PicapicaBooth.",
    faq1Q: "PicapicaBooth có miễn phí để sử dụng không?",
    faq1A: "Có, PicapicaBooth hoàn toàn miễn phí cho tất cả mọi người.",
    faq2Q: "Tôi cần cài đặt bất kỳ phần mềm nào không?",
    faq2A: "Không cần cài đặt. Bạn có thể sử dụng PicapicaBooth trực tiếp trong trình duyệt của mình.",
    faq3Q: "Tôi có thể sử dụng PicapicaBooth trên điện thoại của mình không?",
    faq3A: "Có, PicapicaBooth hoạt động trên cả máy tính để bàn và thiết bị di động.",
    faq4Q: "Làm thế nào để chia sẻ dải ảnh của tôi?",
    faq4A: "Bạn có thể tải xuống dải ảnh hoặc chia sẻ trực tiếp lên mạng xã hội."
  },
  pt: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    appName: "PicapicaBooth",
    tagline: "Crie Tiras de Cabine Fotográfica Instantaneamente",
    
    // 语言选择
    selectLanguage: 'Selecionar Idioma',
    
    // 导航菜单
    features: "Recursos",
    gallery: "Galeria",
    home: "Início",
    photoBooth: "Cabine de Fotos",
    preview: "Visualização",
    tutorial: "Tutorial",
    reviews: "Avaliações",
    heroTitle: "Crie Lindas Tiras de Fotos com nossa Cabine de Fotos Online",
    heroDescription: "O PicapicaBooth permite que você capture, edite e compartilhe fotos deslumbrantes sem equipamento profissional, a qualquer hora, em qualquer lugar.",
    getStarted: "Começar",
    learnMore: "Saiba Mais",
    photoBoothTitle: "Picapica Booth - Cabine de Fotos Online Gratuita",
    photoInstruction: "Ajuste suas configurações, selecione um filtro e clique em \"Iniciar Captura\" para criar sua tira de fotos!",
    photoSettings: "Configurações da Foto",
    startCapture: "Iniciar Captura",
    capturing: "Capturando suas fotos no Picapica Booth...",
    standardFilters: "Filtros Padrão",
    professionalFilters: "Filtros Profissionais",
    artisticFilters: "Filtros Artísticos",
    noFilter: "Sem Filtro",
    grayscale: "Escala de Cinza",
    sepia: "Sépia",
    highContrast: "Alto Contraste",
    bright: "Brilhante",
    portraitEnhance: "Realce de Retrato",
    dramaticLight: "Luz Dramática",
    advancedBW: "P&B Avançado",
    filmLook: "Aparência de Filme",
    dreamyBlue: "Azul Sonhador",
    vintageGreen: "Verde Vintage",
    negative: "Negativo",
    darkMood: "Humor Escuro",
    smartDetection: "Detecção inteligente de luz",
    darkLight: "pouca luz",
    brightLight: "luz brilhante",
    normalLight: "luz normal",
    recommendFilter: "Filtro recomendado para melhores resultados",
    applyRecommended: "Aplicar Recomendação",
    previewTitle: "Visualização da Foto do Booth Picapica",
    layoutStyles: "Escolha o Estilo de Layout",
    classicStrip: "Tira Clássica",
    gridLayout: "Layout de Grade",
    polaroidStyle: "Estilo Polaroid",
    magazineCover: "Capa de Revista",
    backgroundColor: "Escolha a Cor de Fundo",
    white: "Branco",
    black: "Preto",
    pink: "Rosa",
    green: "Verde",
    blue: "Azul",
    yellow: "Amarelo",
    purple: "Roxo",
    decorations: "Escolha Decorações",
    girlStickers: "Adesivos de Menina",
    cuteStickers: "Adesivos Fofos",
    noStickers: "Sem Adesivos",
    download: "Baixar Tira de Fotos Picapica Booth",
    takeNew: "Tirar Novas Fotos com Picapica Booth",
    share: "Compartilhar Sua Criação PicapicaBooth",
    shareTitle: "Compartilhar Sua Criação Picapica Booth",
    socialMedia: "Redes Sociais",
    emailInvite: "Convite por Email",
    copyLink: "Copiar Link",
    linkCopied: "Link Copiado!",
    faqTitle: "Perguntas Frequentes",
    faqSubtitle: "Perguntas comuns sobre o PicapicaBooth",
    copyright: "© 2025 PicapicaBooth. Todos os Direitos Reservados.",
    about: "Sobre Nós",
    contact: "Contato",
    privacy: "Política de Privacidade",
    terms: "Termos de Serviço",
    switchToChinese: "Mudar para Chinês",
    switchToEnglish: "Mudar para Inglês",
    showcaseTitle: "Criatividade Ilimitada, Resultados Impressionantes",
    showcaseIntro: "Confira lindas tiras de fotos criadas por usuários com o PicapicaBooth",
    showcaseAlt1: "Exemplo de tira de fotos 1",
    showcaseAlt2: "Exemplo de tira de fotos 2",
    showcaseAlt3: "Exemplo de tira de fotos 3",
    showcaseAlt4: "Exemplo de tira de fotos 4",
    ctaTitle: "Pronto para Criar Sua Tira de Fotos com o PicapicaBooth?",
    ctaDesc: "Comece a usar o PicapicaBooth agora para capturar e compartilhar seus momentos incríveis!",
    footerSlogan: "Crie lindas tiras de fotos com nossa cabine de fotos online",
    footerProduct: "Produto",
    footerSupport: "Suporte",
    footerCompany: "Empresa",
    contactUs: "Fale Conosco",
    privacyPolicy: "Política de Privacidad",
    aboutUs: "Sobre Nós",
    blog: "Blog",
    careers: "Carreiras",
    footerCopyright: "Todos os Direitos Reservados.",
    photoCapture: "Captura de Fotos",
    photoCaptureDesc: "Tire fotos de alta qualidade facilmente com seu dispositivo.",
    creativeFilters: "Filtros Criativos",
    creativeFiltersDesc: "Aplique uma variedade de filtros divertidos e artísticos às suas fotos.",
    photoStripGeneration: "Geração de Tiras de Fotos",
    photoStripGenerationDesc: "Gere automaticamente tiras de fotos clássicas.",
    easySharing: "Compartilhamento Fácil",
    easySharingDesc: "Compartilhe suas criações instantaneamente com amigos e redes sociais.",
    workflowTitle: "Como Funciona",
    workflowIntro: "Apenas três passos simples para criar sua tira de fotos perfeita.",
    workflowStep1: "Tirar Fotos",
    workflowStep1Desc: "Capture seus melhores momentos usando sua câmera.",
    workflowStep2: "Editar e Decorar",
    workflowStep2Desc: "Aplique filtros e adicione decorações para personalizar suas fotos.",
    workflowStep3: "Baixar e Compartilhar",
    workflowStep3Desc: "Salve sua tira de fotos ou compártela com amigos.",
    testimonialsTitle: "O Que Nossos Usuários Dizem",
    testimonialsIntro: "Feedback real de usuários de PicapicaBooth.",
    testimonial1Name: "Emily Johnson",
    testimonial1Role: "Fotógrafa",
    testimonial1Comment: "PicapicaBooth é tão fácil de usar e os resultados são incríveis!",
    testimonial2Name: "Michael Lee",
    testimonial2Role: "Organizador de Eventos",
    testimonial2Comment: "Nossos convidados adoraram as tiras de fotos instantâneas. Altamente recomendado!",
    testimonial3Name: "Sophia Chen",
    testimonial3Role: "Estudante",
    testimonial3Comment: "Uma maneira divertida de capturar memórias com amigos online.",
    faqIntro: "Aqui estão as respostas para perguntas comuns sobre o PicapicaBooth.",
    faq1Q: "O PicapicaBooth é gratuito para usar?",
    faq1A: "Sim, PicapicaBooth é completamente gratuito para todos.",
    faq2Q: "Preciso instalar algum software?",
    faq2A: "Não é necessário instalar. Você pode usar o PicapicaBooth diretamente no seu navegador.",
    faq3Q: "Posso usar o PicapicaBooth no meu celular?",
    faq3A: "Sim, PicapicaBooth funciona tanto em computadores quanto em dispositivos móveis.",
    faq4Q: "Como posso compartilhar minhas tiras de fotos?",
    faq4A: "Você pode baixar suas tiras de fotos ou compartilhá-las diretamente nas redes sociais."
  },
  ja: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    appName: "PicapicaBooth",
    tagline: "フォトブースストリップを瞬時に作成",
    
    // 语言选择
    selectLanguage: '言語を選択',
    
    // 导航菜单
    features: "機能",
    gallery: "ギャラリー",
    home: "ホーム",
    photoBooth: "フォトブース",
    preview: "プレビュー",
    tutorial: "チュートリアル",
    reviews: "レビュー",
    heroTitle: "私たちのオンラインフォトブースで美しいフォトストリップを作成",
    heroDescription: "PicapicaBoothでは、プロの機材なしでいつでもどこでも素晴らしい写真を撮影、編集、共有することができます。",
    getStarted: "始める",
    learnMore: "詳細を見る",
    photoBoothTitle: "Picapica Booth - 無料オンラインフォトブース",
    photoInstruction: "設定を調整し、フィルターを選択して「撮影開始」をクリックしてフォトストリップを作成しましょう！",
    photoSettings: "写真設定",
    startCapture: "撮影開始",
    capturing: "Picapica Boothで写真を撮影中...",
    standardFilters: "標準フィルター",
    professionalFilters: "プロフェッショナルフィルター",
    artisticFilters: "アーティスティックフィルター",
    noFilter: "フィルターなし",
    grayscale: "グレースケール",
    sepia: "セピア",
    highContrast: "ハイコントラスト",
    bright: "ブライト",
    portraitEnhance: "ポートレート強化",
    dramaticLight: "ドラマチックライト",
    advancedBW: "高度な白黒",
    filmLook: "フィルムルック",
    dreamyBlue: "ドリーミーブルー",
    vintageGreen: "ビンテージグリーン",
    negative: "ネガティブ",
    darkMood: "ダークムード",
    smartDetection: "スマート光検出",
    darkLight: "暗い光",
    brightLight: "明るい光",
    normalLight: "通常の光",
    recommendFilter: "最良の結果のための推奨フィルター",
    applyRecommended: "推奨を適用",
    previewTitle: "Picapicaフォトブース写真のプレビュー",
    layoutStyles: "レイアウトスタイルを選択",
    classicStrip: "クラシックストリップ",
    gridLayout: "グリッドレイアウト",
    polaroidStyle: "ポラロイドスタイル",
    magazineCover: "雑誌カバー",
    backgroundColor: "選択背景色",
    white: "白",
    black: "黒",
    pink: "ピンク",
    green: "緑",
    blue: "青",
    yellow: "黄",
    purple: "紫",
    decorations: "装飾を選択",
    girlStickers: "ガールステッカー",
    cuteStickers: "カワイステッカー",
    noStickers: "ステッカーなし",
    download: "Picapica Boothフォトストリップをダウンロード",
    takeNew: "Picapica Boothで新しい写真を撮る",
    share: "PicapicaBoothの作品を共有",
    shareTitle: "Picapica Boothの作品を共有",
    socialMedia: "ソーシャルメディア",
    emailInvite: "メール招待",
    copyLink: "リンクをコピー",
    linkCopied: "リンクがコピーされました！",
    faqTitle: "よくある質問",
    faqSubtitle: "PicapicaBoothに関するよくある質問",
    copyright: "© 2025 PicapicaBooth. All Rights Reserved.",
    about: "会社概要",
    contact: "お問い合わせ",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    switchToChinese: "中国語に切り替え",
    switchToEnglish: "英語に切り替え",
    showcaseTitle: "無限の創造性、印象的な結果",
    showcaseIntro: "PicapicaBoothで作成されたユーザーの美しいフォトストリップをご覧ください",
    showcaseAlt1: "フォトストリップ例1",
    showcaseAlt2: "フォトストリップ例2",
    showcaseAlt3: "フォトストリップ例3",
    showcaseAlt4: "フォトストリップ例4",
    ctaTitle: "PicapicaBoothでフォトストリップを作成する準備はできましたか？",
    ctaDesc: "今すぐPicapicaBoothを使用して、素晴らしい瞬間を撮影し共有しましょう！",
    footerSlogan: "私たちのオンラインフォトブースで美しいフォトストリップを作成",
    footerProduct: "製品",
    footerSupport: "サポート",
    footerCompany: "会社",
    contactUs: "お問い合わせ",
    privacyPolicy: "プライバシーポリシー",
    aboutUs: "Tentang Kami",
    blog: "ブログ",
    careers: "Tuyển Dụng",
    footerCopyright: "All Rights Reserved.",
    photoCapture: "写真撮影",
    photoCaptureDesc: "デバイスで簡単に高品質の写真を撮影できます。",
    creativeFilters: "クリエイティブフィルター",
    creativeFiltersDesc: "写真に様々な楽しいアーティスティックなフィルターを適用します。",
    photoStripGeneration: "フォトストリップ生成",
    photoStripGenerationDesc: "クラシックなフォトストリップを自動的に生成します。",
    easySharing: "簡単な共有",
    easySharingDesc: "友達やソーシャルメディアとすぐに作品を共有できます。",
    workflowTitle: "使い方",
    workflowIntro: "完璧なフォトストリップを作成するための3つの簡単なステップ。",
    workflowStep1: "写真を撮る",
    workflowStep1Desc: "カメラを使用して最高の瞬間を撮影します。",
    workflowStep2: "編集と装飾",
    workflowStep2Desc: "フィルターを適用し、装飾を追加して写真をパーソナライズします。",
    workflowStep3: "ダウンロードと共有",
    workflowStep3Desc: "フォトストリップを保存するか、友達と共有します。",
    testimonialsTitle: "ユーザーの声",
    testimonialsIntro: "PicapicaBoothユーザーからの実際のフィードバック。",
    testimonial1Name: "エミリー・ジョンソン",
    testimonial1Role: "フォトグラファー",
    testimonial1Comment: "PicapicaBoothは使いやすく、結果も素晴らしいです！",
    testimonial2Name: "マイケル・リー",
    testimonial2Role: "イベントオーガナイザー",
    testimonial2Comment: "私たちのゲストはインスタントフォトストリップを気に入ってくれました。強くお勧めします！",
    testimonial3Name: "ソフィア・チェン",
    testimonial3Role: "学生",
    testimonial3Comment: "オンラインで友達と思い出を作る楽しい方法です。",
    faqIntro: "PicapicaBoothに関するよくある質問への回答です。",
    faq1Q: "PicapicaBoothは無料で使えますか？",
    faq1A: "はい、PicapicaBoothは誰でも完全に無料で使えます。",
    faq2Q: "ソフトウェアをインストールする必要がありますか？",
    faq2A: "インストールは不要です。ブラウザで直接PicapicaBoothを使用できます。",
    faq3Q: "スマートフォンでPicapicaBoothを使用できますか？",
    faq3A: "はい、PicapicaBoothはデスクトップとモバイルデバイスの両方で動作します。",
    faq4Q: "フォトストリップを共有するにはどうすればいいですか？",
    faq4A: "フォトストリップをダウンロードするか、ソーシャルメディアに直接共有できます。",

    // Beauty Features
    beautyFeature: "美顔機能",
    enableBeauty: "美顔を有効にする",
    smoothLevel: "スムーズ",
    brightnessLevel: "明るさ",
    enhanceLevel: "強調",
    faceSlimLevel: "小顔",
    eyeEnlargeLevel: "目を大きく",
    resetBeauty: "リセット",
    natural: "ナチュラル",
    fresh: "フレッシュ",
    glamour: "グラマー",
    cute: "かわいい",
  },
  th: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    appName: "PicapicaBooth",
    tagline: "สร้างสตริปบูธถ่ายรูปทันที",
    
    // 语言选择
    selectLanguage: 'เลือกภาษา',
    
    // 导航菜单
    features: "คุณสมบัติ",
    gallery: "แกลเลอรี่",
    home: "หน้าแรก",
    photoBooth: "ตู้ถ่ายรูป",
    preview: "ตัวอย่าง",
    tutorial: "วิธีใช้งาน",
    reviews: "รีวิว",
    heroTitle: "สร้างสตริปภาพสวยๆ ด้วยตู้ถ่ายรูปออนไลน์ของเรา",
    heroDescription: "PicapicaBooth ช่วยให้คุณถ่าย แก้ไข และแชร์ภาพถ่ายสวยๆ ได้โดยไม่ต้องใช้อุปกรณ์มืออาชีพ ทุกที่ ทุกเวลา",
    getStarted: "เริ่มต้นใช้งาน",
    learnMore: "เรียนรู้เพิ่มเติม",
    photoBoothTitle: "Picapica Booth - ตู้ถ่ายรูปออนไลน์ฟรี",
    photoInstruction: "ปรับการตั้งค่า เลือกฟิลเตอร์ และคลิก 'เริ่มถ่าย' เพื่อสร้างสตริปภาพของคุณ!",
    photoSettings: "ตั้งค่าภาพถ่าย",
    startCapture: "เริ่มถ่าย",
    capturing: "กำลังถ่ายภาพ Picapica Booth ของคุณ...",
    standardFilters: "ฟิลเตอร์มาตรฐาน",
    professionalFilters: "ฟิลเตอร์ระดับมืออาชีพ",
    artisticFilters: "ฟิลเตอร์ศิลปะ",
    noFilter: "ไม่มีฟิลเตอร์",
    grayscale: "โทนสีเทา",
    sepia: "เซเปีย",
    highContrast: "คอนทราสต์สูง",
    bright: "สว่าง",
    portraitEnhance: "เสริมภาพบุคคล",
    dramaticLight: "แสงดรามาติก",
    advancedBW: "ขาวดำขั้นสูง",
    filmLook: "ลุคฟิล์ม",
    dreamyBlue: "ฝันสีฟ้า",
    vintageGreen: "สีเขียววินเทจ",
    negative: "เนกาทีฟ",
    darkMood: "อารมณ์มืด",
    smartDetection: "การตรวจจับแสงอัจฉริยะ",
    darkLight: "แสงน้อย",
    brightLight: "แสงจ้า",
    normalLight: "แสงปกติ",
    recommendFilter: "ฟิลเตอร์แนะนำเพื่อผลลัพธ์ที่ดีที่สุด",
    applyRecommended: "ใช้ที่แนะนำ",
    previewTitle: "ดูตัวอย่างภาพตู้ Picapica",
    layoutStyles: "เลือกรูปแบบเลย์เอาต์",
    classicStrip: "สตริปคลาสสิก",
    gridLayout: "เลย์เอาต์กริด",
    polaroidStyle: "สไตล์โพลารอยด์",
    magazineCover: "ปกนิตยสาร",
    backgroundColor: "เลือกสีพื้นหลัง",
    white: "ขาว",
    black: "ดำ",
    pink: "ชมพู",
    green: "เขียว",
    blue: "น้ำเงิน",
    yellow: "เหลือง",
    purple: "ม่วง",
    decorations: "เลือกการตกแต่ง",
    girlStickers: "สติกเกอร์ผู้หญิง",
    cuteStickers: "สติกเกอร์น่ารัก",
    noStickers: "ไม่มีสติกเกอร์",
    download: "ดาวน์โหลดสตริปภาพ Picapica Booth",
    takeNew: "ถ่ายภาพใหม่ด้วย Picapica Booth",
    share: "แชร์ผลงาน PicapicaBooth ของคุณ",
    shareTitle: "แชร์ผลงาน Picapica Booth ของคุณ",
    socialMedia: "โซเชียลมีเดีย",
    emailInvite: "เชิญทางอีเมล",
    copyLink: "คัดลอกลิงก์",
    linkCopied: "คัดลอกลิงก์แล้ว!",
    faqTitle: "คำถามที่พบบ่อย",
    faqSubtitle: "คำถามทั่วไปเกี่ยวกับ PicapicaBooth",
    copyright: "© 2025 PicapicaBooth. สงวนลิขสิทธิ์ทั้งหมด",
    about: "เกี่ยวกับเรา",
    contact: "ติดต่อ",
    privacy: "นโยบายความเป็นส่วนตัว",
    terms: "ข้อกำหนดการใช้งาน",
    switchToChinese: "เปลี่ยนเป็นภาษาจีน",
    switchToEnglish: "เปลี่ยนเป็นภาษาอังกฤษ",
    showcaseTitle: "ความคิดสร้างสรรค์ไร้ขีดจำกัด ผลลัพธ์ที่น่าประทับใจ",
    showcaseIntro: "ดูสตริปภาพสวยๆ ที่สร้างโดยผู้ใช้ด้วย PicapicaBooth",
    showcaseAlt1: "ตัวอย่างสตริปภาพ 1",
    showcaseAlt2: "ตัวอย่างสตริปภาพ 2",
    showcaseAlt3: "ตัวอย่างสตริปภาพ 3",
    showcaseAlt4: "ตัวอย่างสตริปภาพ 4",
    ctaTitle: "พร้อมที่จะสร้างสตริปภาพของคุณด้วย PicapicaBooth หรือยัง?",
    ctaDesc: "เริ่มใช้ PicapicaBooth ตอนนี้เพื่อถ่ายและแชร์ช่วงเวลาที่ยอดเยี่ยมของคุณ!",
    footerSlogan: "สร้างสตริปภาพสวยๆ ด้วยตู้ถ่ายรูปออนไลน์ของเรา",
    footerProduct: "ผลิตภัณฑ์",
    footerSupport: "การสนับสนุน",
    footerCompany: "บริษัท",
    contactUs: "ติดต่อเรา",
    privacyPolicy: "นโยบายความเป็นส่วนตัว",
    aboutUs: "Tentang Kami",
    blog: "Blog",
    careers: "Tuyển Dụng",
    footerCopyright: "สงวนลิขสิทธิ์ทั้งหมด",
    photoCapture: "การถ่ายภาพ",
    photoCaptureDesc: "ถ่ายภาพคุณภาพสูงได้อย่างง่ายดายด้วยอุปกรณ์ของคุณ",
    creativeFilters: "ฟิลเตอร์สร้างสรรค์",
    creativeFiltersDesc: "ใช้ฟิลเตอร์สนุกๆ และศิลปะหลากหลายกับภาพถ่ายของคุณ",
    photoStripGeneration: "การสร้างสตริปภาพ",
    photoStripGenerationDesc: "สร้างสตริปภาพคลาสสิกโดยอัตโนมัติ",
    easySharing: "แชร์ง่าย",
    easySharingDesc: "แชร์ผลงานของคุณกับเพื่อนและโซเชียลมีเดียได้ทันที",
    workflowTitle: "วิธีการทำงาน",
    workflowIntro: "Chỉ ba bước đơn giản để tạo dải ảnh hoàn hảo của bạn.",
    workflowStep1: "Chụp ảnh",
    workflowStep1Desc: "Chụp những khoảnh khắc đẹp nhất của bạn bằng máy ảnh.",
    workflowStep2: "Chỉnh Sửa & Trang Trí",
    workflowStep2Desc: "Áp dụng bộ lọc và thêm trang trí để cá nhân hóa ảnh của bạn.",
    workflowStep3: "Tải Xuống & Chia Sẻ",
    workflowStep3Desc: "Lưu dải ảnh của bạn hoặc chia sẻ với bạn bè.",
    testimonialsTitle: "Người Dùng Nói Gì",
    testimonialsIntro: "Phản hồi thực tế từ người dùng PicapicaBooth.",
    testimonial1Name: "Emily Johnson",
    testimonial1Role: "Nhiếp Ảnh Gia",
    testimonial1Comment: "PicapicaBooth rất dễ sử dụng và hasilnya luar biasa!",
    testimonial2Name: "Michael Lee",
    testimonial2Role: "Người Tổ Chức Sự Kiện",
    testimonial2Comment: "Tamu kami menyukai strip foto instan. Sangat direkomendasikan!",
    testimonial3Name: "Sophia Chen",
    testimonial3Role: "Sinh Viên",
    testimonial3Comment: "Một cách thú vị để lưu giữ kỷ niệm với bạn bè trực tuyến.",
    faqIntro: "Đây là câu trả lời cho các câu hỏi phổ biến về PicapicaBooth.",
    faq1Q: "PicapicaBooth có miễn phí để sử dụng không?",
    faq1A: "Có, PicapicaBooth hoàn toàn miễn phí cho tất cả mọi người.",
    faq2Q: "Tôi cần cài đặt phần mềm gì không?",
    faq2A: "Không cần cài đặt. Bạn có thể sử dụng PicapicaBooth trực tiếp trong trình duyệt của mình.",
    faq3Q: "Tôi có thể sử dụng PicapicaBooth trên điện thoại của mình không?",
    faq3A: "Có, PicapicaBooth hoạt động trên cả máy tính để bàn và thiết bị di động.",
    faq4Q: "Làm thế nào để chia sẻ dải ảnh của tôi?",
    faq4A: "Bạn có thể tải xuống dải ảnh hoặc chia sẻ trực tiếp lên mạng xã hội."
  },
  es: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    appName: "PicapicaBooth",
    tagline: "Crea Tiras de Fotomatón al Instante",
    
    // 语言选择
    selectLanguage: 'Seleccionar Idioma',
    
    // 导航菜单
    features: "Características",
    gallery: "Galería",
    home: "Inicio",
    photoBooth: "Cabina de Fotos",
    preview: "Vista Previa",
    tutorial: "Tutorial",
    reviews: "Opiniones",
    heroTitle: "Crea Hermosas Tiras de Fotos con nuestra Cabina de Fotos Online",
    heroDescription: "PicapicaBooth te permite capturar, editar y compartir fotos impresionantes sin equipo profesional, en cualquier momento y lugar.",
    getStarted: "Comenzar",
    learnMore: "Saber Más",
    photoBoothTitle: "Picapica Booth - Cabina de Fotos Online Gratuita",
    photoInstruction: "¡Ajusta la configuración, selecciona un filtro y haz clic en 'Iniciar Captura' para crear tu tira de fotos!",
    photoSettings: "Ajustes de Foto",
    startCapture: "Iniciar Captura",
    capturing: "Capturando tus fotos de Picapica Booth...",
    standardFilters: "Filtros Estándar",
    professionalFilters: "Filtros Profesionales",
    artisticFilters: "Filtros Artísticos",
    noFilter: "Sin Filtro",
    grayscale: "Escala de Grises",
    sepia: "Sepia",
    highContrast: "Alto Contraste",
    bright: "Brillante",
    portraitEnhance: "Mejora de Retrato",
    dramaticLight: "Luz Dramática",
    advancedBW: "B&N Avanzado",
    filmLook: "Aspecto de Película",
    dreamyBlue: "Azul Soñador",
    vintageGreen: "Verde Vintage",
    negative: "Negativo",
    darkMood: "Ambiente Oscuro",
    smartDetection: "Detección inteligente de luz",
    darkLight: "poca luz",
    brightLight: "luz brillante",
    normalLight: "luz normal",
    recommendFilter: "Filtro recomendado para mejores resultados",
    applyRecommended: "Aplicar Recomendado",
    previewTitle: "Vista Previa de Foto de Cabina Picapica",
    layoutStyles: "Elige Estilo de Diseño",
    classicStrip: "Tira Clásica",
    gridLayout: "Diseño de Cuadrícula",
    polaroidStyle: "Estilo Polaroid",
    magazineCover: "Portada de Revista",
    backgroundColor: "Elige Color de Fondo",
    white: "Blanco",
    black: "Negro",
    pink: "Rosa",
    green: "Verde",
    blue: "Azul",
    yellow: "Amarillo",
    purple: "Morado",
    decorations: "Elige Decoraciones",
    girlStickers: "Pegatinas de Chicas",
    cuteStickers: "Pegatinas Lindas",
    noStickers: "Sin Pegatinas",
    download: "Descargar Tira de Fotos Picapica Booth",
    takeNew: "Tomar Nuevas Fotos con Picapica Booth",
    share: "Compartir Tu Creación PicapicaBooth",
    shareTitle: "Compartir Tu Creación Picapica Booth",
    socialMedia: "Redes Sociales",
    emailInvite: "Invitación por Email",
    copyLink: "Copiar Enlace",
    linkCopied: "¡Enlace Copiado!",
    faqTitle: "Preguntas Frecuentes",
    faqSubtitle: "Preguntas comunes sobre PicapicaBooth",
    copyright: "© 2025 PicapicaBooth. Todos los Derechos Reservados.",
    about: "Acerca de",
    contact: "Contacto",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio",
    switchToChinese: "Cambiar a Chino",
    switchToEnglish: "Cambiar a Inglés",
    showcaseTitle: "Creatividad Ilimitada, Resultados Impresionantes",
    showcaseIntro: "Mira hermosas tiras de fotos creadas por usuarios con PicapicaBooth",
    showcaseAlt1: "Ejemplo de tira de fotos 1",
    showcaseAlt2: "Ejemplo de tira de fotos 2",
    showcaseAlt3: "Ejemplo de tira de fotos 3",
    showcaseAlt4: "Ejemplo de tira de fotos 4",
    ctaTitle: "¿Listo para Crear Tu Tira de Fotos con PicapicaBooth?",
    ctaDesc: "¡Comienza a usar PicapicaBooth ahora para capturar y compartir tus increíbles momentos!",
    footerSlogan: "Crea hermosas tiras de fotos con nuestra cabina de fotos online",
    footerProduct: "Producto",
    footerSupport: "Soporte",
    footerCompany: "Empresa",
    contactUs: "Contáctanos",
    privacyPolicy: "Política de Privacidad",
    aboutUs: "Acerca de Nosotros",
    blog: "Blog",
    careers: "Carreras",
    footerCopyright: "Todos los Derechos Reservados.",
    photoCapture: "Captura de Fotos",
    photoCaptureDesc: "Toma fotos de alta calidad fácilmente con tu dispositivo.",
    creativeFilters: "Filtros Creativos",
    creativeFiltersDesc: "Aplica una variedad de filtros divertidos y artísticos a tus fotos.",
    photoStripGeneration: "Generación de Tiras de Fotos",
    photoStripGenerationDesc: "Genera automáticamente tiras de fotos clásicas.",
    easySharing: "Compartir Fácilmente",
    easySharingDesc: "Comparte tus creaciones instantáneamente con amigos y redes sociales.",
    workflowTitle: "Cómo Funciona",
    workflowIntro: "Solo tres sencillos pasos para crear tu tira de fotos perfecta.",
    workflowStep1: "Tomar Fotos",
    workflowStep1Desc: "Captura tus mejores momentos usando tu cámara.",
    workflowStep2: "Editar y Decorar",
    workflowStep2Desc: "Aplica filtros y añade decoraciones para personalizar tus fotos.",
    workflowStep3: "Descargar y Compartir",
    workflowStep3Desc: "Guarda tu tira de fotos o compártela con amigos.",
    testimonialsTitle: "Lo Que Dicen Nuestros Usuarios",
    testimonialsIntro: "Feedback real de usuarios de PicapicaBooth.",
    testimonial1Name: "Emily Johnson",
    testimonial1Role: "Fotógrafa",
    testimonial1Comment: "¡PicapicaBooth es tan fácil de usar y los resultados son increíbles!",
    testimonial2Name: "Michael Lee",
    testimonial2Role: "Organizador de Eventos",
    testimonial2Comment: "Nuestros invitados adoraron las tiras de fotos instantáneas. ¡Muy recomendable!",
    testimonial3Name: "Sophia Chen",
    testimonial3Role: "Estudiante",
    testimonial3Comment: "Una forma divertida de capturar recuerdos con amigos online.",
    faqIntro: "Aquí están las respuestas a preguntas comunes sobre PicapicaBooth.",
    faq1Q: "¿Es PicapicaBooth gratuito para usar?",
    faq1A: "Sí, PicapicaBooth es completamente gratuito para todos.",
    faq2Q: "¿Necesito instalar algún software?",
    faq2A: "No es necesario instalar. Puedes usar PicapicaBooth directamente en tu navegador.",
    faq3Q: "¿Puedo usar PicapicaBooth en mi teléfono?",
    faq3A: "Sí, PicapicaBooth funciona tanto en ordenadores como en dispositivos móviles.",
    faq4Q: "¿Cómo puedo compartir mis tiras de fotos?",
    faq4A: "Puedes descargar tus tiras de fotos o compartirlas directamente en redes sociales."
  },
  it: {
    quickFilters: "Quick Filters",
    moreFilters: "More Filters",
    hideMoreFilters: "Hide More Filters",
    finalResultPreview: "See What You'll Create",
    exampleDescription: "This is what your final photo strip will look like!",
    withFilters: "With Filters",
    downloadable: "Downloadable",
    photos: "photos",
    loading: "Loading...",
    cameraPermissionDenied: "Camera permission is required to use the photo booth. Please allow camera access.",
    cameraNotFound: "No camera detected. Please make sure your device has a camera and it is connected.",
    cameraInUse: "Your camera may be in use by another application. Close other apps using the camera, then refresh the page.",
    cameraAccessError: "Unable to access the camera. Please refresh the page and check your browser settings.",
    cameraPlaybackError: "Unable to play the camera video. Please refresh the page or check your browser settings.",
    noAccountTitle: "No Account Needed",
    noAccountDescription: "Picapica Booth is completely free. No account, signup, or subscription is needed to create your photo strips.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    appName: "PicapicaBooth",
    tagline: "Crea Strisce da Cabina Fotografica Istantaneamente",
    
    // 语言选择
    selectLanguage: 'Seleziona Lingua',
    
    // 导航菜单
    features: "Funzionalità",
    gallery: "Galleria",
    home: "Home",
    photoBooth: "Cabina Fotografica",
    preview: "Anteprima",
    tutorial: "Tutorial",
    reviews: "Recensioni",
    heroTitle: "Crea Bellissime Strisce Fotografiche con la nostra Cabina Fotografica Online",
    heroDescription: "PicapicaBooth ti permette di catturare, modificare e condividere foto straordinarie senza attrezzature professionali, in qualsiasi momento e ovunque.",
    getStarted: "Inizia Ora",
    learnMore: "Scopri di Più",
    photoBoothTitle: "Picapica Booth - Cabina Fotografica Online Gratuita",
    photoInstruction: "Regola le impostazioni, seleziona un filtro e clicca su 'Inizia Acquisizione' per creare la tua striscia fotografica!",
    photoSettings: "Impostazioni Foto",
    startCapture: "Inizia Acquisizione",
    capturing: "Acquisizione delle tue foto Picapica Booth in corso...",
    standardFilters: "Filtri Standard",
    professionalFilters: "Filtri Professionali",
    artisticFilters: "Filtri Artistici",
    noFilter: "Nessun Filtro",
    grayscale: "Scala di Grigi",
    sepia: "Seppia",
    highContrast: "Alto Contrasto",
    bright: "Luminoso",
    portraitEnhance: "Miglioramento Ritratto",
    dramaticLight: "Luce Drammatica",
    advancedBW: "B&N Avanzato",
    filmLook: "Aspetto Pellicola",
    dreamyBlue: "Blu Sognante",
    vintageGreen: "Verde Vintage",
    negative: "Negativo",
    darkMood: "Atmosfera Scura",
    smartDetection: "Rilevamento intelligente della luce",
    darkLight: "luce scarsa",
    brightLight: "luce intensa",
    normalLight: "luce normale",
    recommendFilter: "Filtro consigliato per risultati migliori",
    applyRecommended: "Applica Consigliato",
    previewTitle: "Anteprima Foto Cabina Picapica",
    layoutStyles: "Scegli Stile Layout",
    classicStrip: "Striscia Classica",
    gridLayout: "Layout a Griglia",
    polaroidStyle: "Stile Polaroid",
    magazineCover: "Copertina Rivista",
    backgroundColor: "Scegli Colore Sfondo",
    white: "Bianco",
    black: "Nero",
    pink: "Rosa",
    green: "Verde",
    blue: "Blu",
    yellow: "Giallo",
    purple: "Viola",
    decorations: "Scegli Decorazioni",
    girlStickers: "Adesivi Ragazza",
    cuteStickers: "Adesivi Carini",
    noStickers: "Nessun Adesivo",
    download: "Scarica Striscia Fotografica Picapica Booth",
    takeNew: "Scatta Nuove Foto con Picapica Booth",
    share: "Condividi La Tua Creazione PicapicaBooth",
    shareTitle: "Condividi La Tua Creazione Picapica Booth",
    socialMedia: "Social Media",
    emailInvite: "Invito Email",
    copyLink: "Copia Link",
    linkCopied: "Link Copiato!",
    faqTitle: "Domande Frequenti",
    faqSubtitle: "Domande comuni su PicapicaBooth",
    copyright: "© 2025 PicapicaBooth. Tutti i Diritti Riservati.",
    about: "Chi Siamo",
    contact: "Contatti",
    privacy: "Informativa sulla Privacy",
    terms: "Termini di Servizio",
    switchToChinese: "Passa al Cinese",
    switchToEnglish: "Passa all'Inglese",
    showcaseTitle: "Creatività Illimitata, Risultati Impressionanti",
    showcaseIntro: "Guarda bellissime strisce fotografiche create dagli utenti con PicapicaBooth",
    showcaseAlt1: "Esempio striscia fotografica 1",
    showcaseAlt2: "Esempio striscia fotografica 2",
    showcaseAlt3: "Esempio striscia fotografica 3",
    showcaseAlt4: "Esempio striscia fotografica 4",
    ctaTitle: "Pronto per Creare la Tua Striscia Fotografica con PicapicaBooth?",
    ctaDesc: "Inizia a utilizzare PicapicaBooth ora per catturare e condividere i tuoi momenti incredibili!",
    footerSlogan: "Crea bellissime strisce fotografiche con la nostra cabina fotografica online",
    footerProduct: "Prodotto",
    footerSupport: "Supporto",
    footerCompany: "Azienda",
    contactUs: "Contattaci",
    privacyPolicy: "Informativa sulla Privacy",
    aboutUs: "Chi Siamo",
    blog: "Blog",
    careers: "Carriere",
    footerCopyright: "Tutti i Diritti Riservati.",
    photoCapture: "Acquisizione Foto",
    photoCaptureDesc: "Scatta foto di alta qualità facilmente con il tuo dispositivo.",
    creativeFilters: "Filtri Creativi",
    creativeFiltersDesc: "Applica una varietà di filtri divertenti e artistici alle tue foto.",
    photoStripGeneration: "Generazione Strisce Fotografiche",
    photoStripGenerationDesc: "Genera automaticamente strisce fotografiche classiche.",
    easySharing: "Condivisione Facile",
    easySharingDesc: "Condividi le tue creazioni istantaneamente con amici e social media.",
    workflowTitle: "Come Funziona",
    workflowIntro: "Solo tre semplici passaggi per creare la tua striscia fotografica perfetta.",
    workflowStep1: "Scatta Foto",
    workflowStep1Desc: "Cattura i tuoi momenti migliori usando la tua fotocamera.",
    workflowStep2: "Modifica e Decora",
    workflowStep2Desc: "Applica filtri e aggiungi decorazioni per personalizzare le tue foto.",
    workflowStep3: "Scarica e Condividi",
    workflowStep3Desc: "Salva la tua striscia fotografica o condividila con gli amici.",
    testimonialsTitle: "Cosa Dicono i Nostri Utenti",
    testimonialsIntro: "Feedback reali dagli utenti di PicapicaBooth.",
    testimonial1Name: "Emily Johnson",
    testimonial1Role: "Fotografa",
    testimonial1Comment: "PicapicaBooth è così facile da usare e i risultati sono incredibili!",
    testimonial2Name: "Michael Lee",
    testimonial2Role: "Organizzatore di Eventi",
    testimonial2Comment: "I nostri ospiti hanno adorato le strisce fotografiche istantanee. Altamente consigliato!",
    testimonial3Name: "Sophia Chen",
    testimonial3Role: "Studentessa",
    testimonial3Comment: "Un modo divertente per catturare ricordi con gli amici online.",
    faqIntro: "Ecco le risposte alle domande comuni su PicapicaBooth.",
    faq1Q: "PicapicaBooth è gratuito da usare?",
    faq1A: "Sì, PicapicaBooth è completamente gratuito per tutti.",
    faq2Q: "Devo installare qualche software?",
    faq2A: "Non è necessario installare nulla. Puoi usare PicapicaBooth direttamente nel tuo browser.",
    faq3Q: "Posso usare PicapicaBooth sul mio telefono?",
    faq3A: "Sì, PicapicaBooth funziona sia su computer che su dispositivi mobili.",
    faq4Q: "Come posso condividere le mie strisce fotografiche?",
    faq4A: "Puoi scaricare le tue strisce fotografiche o condividerle direttamente sui social media."
  },
};

export default translations;
